import { StreamActions } from '@hotwired/turbo'

// Turbo stream action "upsert": replaces the element with the same id where it already is, or appends it to the
// target when it isn't on the page yet (a voice message first shown on an update). A plain append moves an existing
// element to the end, so a reply saved after the shopper wrote again would jump below their newer message.
export function upsert() {
  const content = this.templateContent
  const id = content.firstElementChild?.id
  const existing = id && document.getElementById(id)

  if (existing) {
    existing.replaceWith(content)
  } else {
    this.targetElements.forEach((target) => target.append(content))
  }
}

StreamActions.upsert = upsert
